import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { FeatureGuard } from '#core/components/auth/feature.guard';
import { isAnyFeatureEnabledGuard } from '#core/experimentation/experimentation.guard';
import { organizationUsersReadGuard } from '#core/guards/organization-users-read.guard';
import { AGGREGATED_PLATFORMS_ROUTES } from '#modules/platforms/routing/aggregated-platforms.routing';
import {
    AGGREGATED_CONFIGURATION_PATH,
    AGGREGATED_CONFIGURATION_TABS,
    ONBOARDING_CONFIGURATION_TAB,
    openFirstEnabledConfigurationTabGuard,
    SENDER_ADDRESS_CONFIGURATION_TAB,
} from '#shell/layouts/logged-in-layout/groups/aggregated-configuration-layout/aggregated-configuration-tabs';

export const AGGREGATED_SETTINGS_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'platforms',
    },
    {
        path: 'platforms',
        loadChildren: () => AGGREGATED_PLATFORMS_ROUTES,
        data: { routePath: RoutePath.PLATFORMS },
    },
    {
        path: 'restaurant-groups',
        loadChildren: () => import('#modules/restaurant-groups/routes/restaurant-groups.routes').then((m) => m.RESTAURANT_GROUPS_ROUTES),
        data: { routePath: RoutePath.RESTAURANT_GROUPS },
    },
    {
        path: 'users',
        loadChildren: () => import('#modules/user/routes/organization-users.routing').then((m) => m.ORGANIZATION_USERS_ROUTES),
        canActivate: [organizationUsersReadGuard],
        data: { routePath: RoutePath.USERS },
    },
    {
        path: 'reports',
        loadChildren: () => import('#modules/custom-reports/custom-reports.routes').then((m) => m.CUSTOM_REPORTS_ROUTES),
        canActivate: [FeatureGuard],
        data: { routePath: RoutePath.REPORTS, feature: 'release-custom-reports' },
    },
    {
        path: 'configuration',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-configuration-layout/aggregated-configuration-layout.component').then(
                (m) => m.AggregatedConfigurationLayoutComponent
            ),
        canActivate: [isAnyFeatureEnabledGuard(AGGREGATED_CONFIGURATION_TABS.map((tab) => tab.featureName))],
        data: { routePath: RoutePath.CONFIGURATION },
        children: [
            { path: '', pathMatch: 'full', canActivate: [openFirstEnabledConfigurationTabGuard], children: [] },
            {
                path: ONBOARDING_CONFIGURATION_TAB.link,
                canActivate: [isAnyFeatureEnabledGuard([ONBOARDING_CONFIGURATION_TAB.featureName], AGGREGATED_CONFIGURATION_PATH)],
                loadChildren: () =>
                    import('#modules/restaurants/routes/restaurants-completion.routes').then((m) => m.RESTAURANTS_COMPLETION_ROUTES),
            },
            {
                path: SENDER_ADDRESS_CONFIGURATION_TAB.link,
                canActivate: [isAnyFeatureEnabledGuard([SENDER_ADDRESS_CONFIGURATION_TAB.featureName], AGGREGATED_CONFIGURATION_PATH)],
                loadChildren: () =>
                    import('#modules/organization-email-sender/routes/organization-email-sender.routes').then(
                        (m) => m.ORGANIZATION_EMAIL_SENDER_ROUTES
                    ),
            },
        ],
    },
];
